import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import logo from "../assets/img/Logo.png";

const Header = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("#hero");
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  const isOnHome = location.pathname === "/";

  /** Scroll to a section on the home page. If we are on a different route,
   *  navigate to the home page first — the effect below handles scrolling
   *  once the home page has mounted. */
  const goToSection = (e, id) => {
    e.preventDefault();
    setIsMobileNavOpen(false);

    if (!isOnHome) {
      navigate(`/#${id}`);
      return;
    }

    const header = document.getElementById("header");
    const section = document.getElementById(id);
    if (section) {
      const offset = header ? header.offsetHeight : 100;
      window.scrollTo({ top: section.offsetTop - offset, behavior: "smooth" });
      setActiveLink(`#${id}`);
    }
  };

  const goHome = (e) => {
    e.preventDefault();
    setIsMobileNavOpen(false);
    if (isOnHome) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  // When arriving on home with a hash (e.g. /#news), scroll to that section
  useEffect(() => {
    if (!isOnHome) return;
    const hash = location.hash.replace("#", "");
    if (!hash) return;
    // Delay so the target section is mounted (esp. Firestore-rendered ones)
    const t = setTimeout(() => {
      const header = document.getElementById("header");
      const section = document.getElementById(hash);
      if (section) {
        const offset = header ? header.offsetHeight : 100;
        window.scrollTo({ top: section.offsetTop - offset, behavior: "smooth" });
      }
    }, 300);
    return () => clearTimeout(t);
  }, [isOnHome, location.hash]);

  useEffect(() => {
    if (!isOnHome) return;
    const handleScroll = () => {
      const sections = ["hero", "about", "news", "portfolio", "documents", "contact"];
      let currentSection = "#hero";
      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = `#${section}`;
          }
        }
      });
      setActiveLink(currentSection);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isOnHome]);

  return (
    <header id="header" className="fixed-top d-flex align-items-center">
      <div className="container d-flex align-items-center justify-content-between">
        <div className="logo">
          <a href="/" onClick={goHome}>
            <img src={logo || null} alt="" style={{ width: "70px", height: "60px" }} />
          </a>
          <div>
            <h1 className="text-light">
              <a href="/" onClick={goHome}>
                <span className="large-text">CDCOT THAILAND</span>
                <span className="small-text">CDCOT</span>
              </a>
            </h1>
            <h4>
              <a href="/" onClick={goHome}>
                <span className="large-text">ชมรมอนุรักษ์และพัฒนาน้ำมันมะพร้าวแห่งประเทศไทย</span>
                <span className="small-text">ชมรมน้ำมันมะพร้าวไทย</span>
              </a>
            </h4>
          </div>
        </div>

        <nav id="navbar" className={`navbar ${isMobileNavOpen ? "navbar-mobile" : ""}`}>
          <ul>
            {[
              { id: "hero", label: "Home" },
              { id: "about", label: "About Us" },
              { id: "news", label: "News" },
              { id: "portfolio", label: "Gallery" },
            ].map((item) => (
              <li key={item.id}>
                <a
                  className={`nav-link scrollto ${
                    isOnHome && activeLink === `#${item.id}` ? "active" : ""
                  }`}
                  href={`/#${item.id}`}
                  onClick={(e) =>
                    item.id === "hero" ? goHome(e) : goToSection(e, item.id)
                  }
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="dropdown">
              <a
                className={`nav-link scrollto ${
                  isOnHome && activeLink === "#documents" ? "active" : ""
                }`}
                href="/#documents"
                onClick={(e) => goToSection(e, "documents")}
              >
                <span>Documents</span> <i className="bi bi-chevron-down"></i>
              </a>
              <ul>
                <li><a href="/#documents" onClick={(e) => goToSection(e, "documents")}>เอกสารกัลปพฤษ์</a></li>
                <li><a href="/#documents" onClick={(e) => goToSection(e, "documents")}>เอกสารวิชาการ</a></li>
                <li><a href="/#documents" onClick={(e) => goToSection(e, "documents")}>เอกสารราชการ</a></li>
              </ul>
            </li>

            <li>
              <a
                className={`nav-link scrollto ${
                  isOnHome && activeLink === "#contact" ? "active" : ""
                }`}
                href="/#contact"
                onClick={(e) => goToSection(e, "contact")}
              >
                Contact
              </a>
            </li>

          </ul>
          <i
            className={`bi ${isMobileNavOpen ? "bi-x" : "bi-list"} mobile-nav-toggle`}
            onClick={toggleMobileNav}
          ></i>
        </nav>
      </div>
    </header>
  );
};

export default Header;
